import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IAcceptAllOfficeConsentsParameters } from '../types/OfficeConsent.parameters';

export const acceptAllOfficeConsents = async (
  params: IAcceptAllOfficeConsentsParameters,
): Promise<void> => {
  const headers = await getAuthHeaders();

  await tempMeeApi.post(
    `/credential-service/offices/${params.officeId}/consents/${params.code}/accept-all`,
    {},
    { headers },
  );
};
